// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loader":"loader_wPlg0","inner":"inner_33W8Y"};